import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'
import * as common from '../common'

import * as dialogs from './dialogs'

@ngCore.Component({
  imports: [
    ds.layout.page.Component,
    ds.overlay.confirmation.Component,
    ds.table.Component,
    ds.tooltip.Directive,
    common.dialogs.page.Component,
    dialogs.setup.Component,
    dialogs.aiGenerate.Component,
  ],
  selector: 'atn-mosaic-dev-pages-page',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.mosaic.dev.pages.Collection} */
  public readonly pagesEc = ngCore.inject(state.mosaic.dev.pages.Collection)

  /** Canonical table input for Mosaic page definitions. */
  public readonly pagesTableConfig = {
    collection: this.pagesEc,
    view: {
      creation: () => this.addClickHandlerCallback(),
      search: true,
      title: 'Pages',
    },
  } satisfies ds.table.ec.Config.Input<state.mosaic.dev.pages.TypeParams>

  public addClickHandlerCallback = () => {
    if (
      this.pagesEc.plugins.currentEntityPlugin.feature.selectors
        .getEditedEntity()
        .asSignal()
    ) {
      this.pagesEc.plugins.editingPlugin.feature.actions.discard
        .from('Table.AddButton.Clicked')
        .dispatch({
          current: true,
        })
    }

    // Add new page
    this.pagesEc.plugins.editingPlugin.feature.actions.edit
      .from('Table.AddButton.Clicked')
      .dispatch()
  }

  public generatePagesClickHandler(): void {
    this.pagesEc.assistant.actions.presentPrompt
      .from('Mosaic.Page.Ai.Generate.Button.Clicked')
      .dispatch()
  }

  public confirmDeletionClickHandler(): void {
    this.pagesEc.plugins.editingPlugin.feature.actions.submit
      .from('Confirmation.Footer.Buttons.Confirm.Clicked')
      .dispatch({ delete: true })
  }

  public cancelDeletionClickHandler(): void {
    this.pagesEc.plugins.editingPlugin.feature.actions.discard
      .from('Confirmation.Footer.Buttons.Cancel.Clicked')
      .dispatch({ delete: true })
  }
}
